import { AfterViewInit, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';
import { GridFilter } from 'src/app/core/models/grid-filter.model';
import { GridSearchFilter } from 'src/app/core/models/grid-search-filter.model';
import { GridComponent } from 'src/app/core/widgets/grid/grid.component';
import { Account } from 'src/app/order/models/account.model';

@Component({
    selector: 'app-opportunity-section',
    templateUrl: './opportunity-section.component.html',
    styleUrls: ['./opportunity-section.component.scss'],
    standalone: false
})
export class OpportunitySectionComponent implements OnInit, AfterViewInit {
  @ViewChild(GridComponent, { static: false}) gridComponent: GridComponent;

  @Input()
  account:Account = new Account();

  oppButtons: GridButton[] = [
    {label: 'Edit', link: '/opportunities/edit/:id', type: 'btn-warning',} as GridButton,
  ]
  oppColumns: GridColumn[] = [
     {active: true, label: '#', field: 'id'} as GridColumn,
     {active: true, label: 'Opportunity', field: 'opportunityName'} as GridColumn,
     {active: true, label: 'Lead', field: 'lead.subject', value: (v, r) => !r.lead ? 'N/A' : r.lead.subject} as GridColumn,
     {active: true, label: 'Status', field: 'status.name'} as GridColumn,
     {active: true, label: 'Est. Close Date', field: 'estimatedCloseDate', value: v => moment(v).format('DD/MM/YYYY')} as GridColumn,
     {active: true, label: 'Actual Close Date', field: 'actualClosedDate'} as GridColumn,
     {active: true, label: 'Actual Revenue', field: 'actualRevenue', value: v => '£' + v} as GridColumn,
     {active: true, label: 'Created At', field: 'createdAt', value: v => moment(v).format('DD/MM/YYYY HH:mm:ss')} as GridColumn,
     {active: true, label: 'Updated At', field: 'updatedAt', value: v => moment(v).format('DD/MM/YYYY HH:mm:ss')} as GridColumn
  ];

   // Org filter handled at API level
   oppFilters: GridFilter[] = [{}as GridFilter]
   oppSearchFields: any = ['subject', 'estimatedRevenue', 'account.name', 'type.name', 'status.name', 'contact.firstName'];

   oppSearchFilters: GridSearchFilter[] = [
     {
       field: 'subject',
       label: 'Subject',
     } as GridSearchFilter,
     {
       field: 'estimatedRevenue',
       label: 'Est. Revenue',
     } as GridSearchFilter,
     {
       field: 'account.name',
       label: 'Account',
     } as GridSearchFilter,
     {
       field: 'type.name',
       label: 'Type',
     } as GridSearchFilter,
     {
       field: 'status.name',
       label: 'Status',
     } as GridSearchFilter,
     {
       field: 'contact.firstName',
       label: 'Contact',
     } as GridSearchFilter,
   ]

  constructor(
    private router:Router
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges){
    // Set sites account id
    if(changes.account) {
      if(changes.account.currentValue.id !== -1) {
        const opportunityFilters = [];
        opportunityFilters.push({
          condition: 'eq',
          value: this.account.id,
          field: 'accountId'
        } as GridFilter)

        // Dynamically add filters
        this.gridComponent.filters = opportunityFilters;

        // Refresh grid
        this.gridComponent.getRecordsForEntity();
      }
    }
  }

  getAccount(r){
    if(r.lead !== undefined){
      this.account.name;
    } else {
      return 'Not Found'
    }
  }

  ngAfterViewInit(){
    const opportunityFilters = [];
    opportunityFilters.push({
      condition: 'eq',
      value: this.account.id,
      field: 'accountId'
    } as GridFilter)

    // Dynamically add filters
    this.gridComponent.filters = opportunityFilters;

    // Refresh grid
    this.gridComponent.getRecordsForEntity();
  }


  newOpportunity(){
    this.router.navigateByUrl('/opportunities/account/' + this.account.id);
  }
}
